import { useContext, useEffect } from "react";
import log from "loglevel";

import SitePlanContext from "../utils/siteplan-context";
import { ACTIONS } from "../utils/site-storage";

import { HeightMap } from "../utils/topography";

const TerrainLoader = (props) => {
  const sitePlanContext = useContext(SitePlanContext);

  if (sitePlanContext.heightMap) {
    if (
      !sitePlanContext.heightMap.boundBox.isBoxWithin(sitePlanContext.boundBox)
    ) {
      sitePlanContext.dispatch({ type: ACTIONS.DELETE_HEIGHT_MAP });
      return <></>;
    }
    return props.children;
  } else {
    HeightMap.createFromBoundBox(sitePlanContext.boundBox.double).then(
      (value) => {
        sitePlanContext.dispatch({
          type: ACTIONS.UPDATE_CONTENT,
          payload: {
            ...sitePlanContext.currentSite,
            heightMapData: value,
          },
        });
      }
    );
    return (
      <section className="padded card">
        <h2>Loading terrain…</h2>
      </section>
    );
  }
};

export default TerrainLoader;
